<template>

    <div class="relative w-full h-full  flex justify-center items-center">
        <transition>
            <div v-if="showLoadingModal"
                class="fixed w-full h-full inset-0 bg-black/30 flex justify-center items-center z-50">
                <div class="w-full h-1/2 flex flex-col justify-center p-3 items-center space-y-5">
                    <div class="flex justify-center space-x-2 mt-3">
                        <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-0"></span>
                        <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-150"></span>
                        <span class="w-3 h-3 bg-white shadow-lg rounded-full animate-bounce-wave delay-300"></span>
                    </div>
                </div>
            </div>
        </transition>

        <transition>
            <ConfirmPasswordModal v-if="showPasswordAuthModal" :editForm="form" @success-edit="successfulUpdate"
                @cancelEdit="cancelEdit" @error-edit="errorOnUpdate" />
        </transition>

        <transition>
            <confirm-phonenumber-modal v-if="showOtpPhoneModal" :phone="form.phone"
                @success="passToPasswordConfirmation" @error="errorOnUpdate" @cancel="cancelOtpconfirmation" />
        </transition>

        <transition>
            <success-update-modal v-if="showSuccessfullUpdateModal" />
        </transition>


        <div class="w-5/6 lg:w-3/5 h-fit bg-white rounded-lg shadow-xl border border-gray-200 p-5 ">
            <form class="w-full  mx-auto h-full py-5 flex flex-col justify-start items-center space-y-10 px-2 lg:px-0">

                <div class="w-full flex flex-col justify-start items-center space-y-2"
                    :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
                    <div class="text-lg lg:text-2xl w-full lg:mb-2">{{ $t('admin_edit.title') }}</div>
                </div>


                <div class="w-full flex flex-col justify-center items-center space-y-2 lg:space-y-5">
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-2 lg:gap-5 w-full">

                        <div>
                            <label for="">{{ $t('admin_edit.email') }}</label>
                            <input type="text" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" v-model="form.email"
                                :class="inputClass(formErrors.email.error)" :placeholder="$t('admin_edit.email')" />
                            <p v-if="formErrors.email.error" class="text-sm text-red-500 mt-1">
                                {{ $t('admin_edit.errors.' + formErrors.email.message) }}
                            </p>
                        </div>

                        <div>
                            <label for="">{{ $t('admin_edit.phone') }}</label>
                            <input type="text" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" v-model="form.phone"
                                :class="inputClass(formErrors.phone.error)" :placeholder="$t('admin_edit.phone')" />
                            <p v-if="formErrors.phone.error" class="text-sm text-red-500 mt-1">
                                {{ $t('admin_edit.errors.' + formErrors.phone.message) }}
                            </p>
                        </div>

                        <div>
                            <label for="">{{ $t('admin_edit.newPassword') }}</label>
                            <input type="password" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                                v-model="form.newPassword" :class="inputClass(formErrors.newPassword.error)"
                                :placeholder="$t('admin_edit.newPassword')" />
                            <p v-if="formErrors.newPassword.error" class="text-sm text-red-500 mt-1">
                                {{ $t('admin_edit.errors.' + formErrors.newPassword.message) }}
                            </p>
                        </div>

                        <div>
                            <label for="">{{ $t('admin_edit.confirmNewPassword') }}</label>
                            <input type="password" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
                                v-model="form.confirmNewPassword"
                                :class="inputClass(formErrors.confirmNewPassword.error)"
                                :placeholder="$t('admin_edit.confirmNewPassword')" />
                            <p v-if="formErrors.confirmNewPassword.error" class="text-sm text-red-500 mt-1">
                                {{ $t("admin_edit.errors." + formErrors.confirmNewPassword.message) }}
                            </p>
                        </div>

                    </div>
                    <div class="flex justify-end items-center w-full ">
                        <div @click="submitNewData"
                            class="px-3 py-2 text-white rounded-lg bg-primary w-full text-center lg:w-fit mt-4 lg:mt-0 hover:cursor-pointer hover:scale-105 transition duration-200">
                            {{ $t('admin_edit.submit') }}</div>
                    </div>
                </div>

            </form>
        </div>
    </div>

</template>


<script setup>
import { onMounted, ref, watch } from 'vue';
import { useAdminStore } from '@/stores/admin';
import SuccessUpdateModal from '@/components/SuccessUpdateModal.vue';
import ConfirmPhonenumberModal from '@/components/ConfirmPhonenumberModal.vue';
import ConfirmPasswordModal from '@/components/ConfirmPasswordModal.vue';

const adminStore = useAdminStore();

const form = ref({
    email: '',
    password: '',
    phone: '',
    newPassword: '',
    confirmNewPassword: '',

});

onMounted(() => {
    form.value.email = adminStore.email;
    form.value.phone = adminStore.phone;
})

const inputClass = hasError =>
    (hasError ? 'border border-red-400 ' : 'border border-primary ') +
    ' transition duration-200 outline-none w-full rounded px-3 py-2 text-sm lg:text-base'


const formErrors = ref({
    email: { error: false, message: '' },
    password: { error: false, message: '' },
    phone: { error: false, message: '' },
    newPassword: { error: false, message: '' },
    confirmNewPassword: { error: false, message: '' },
});


watch(
    () => form.value.phone,
    (newVal) => {
        form.value.phone = newVal.replace(/\D/g, "");
    }
);

const validatePhone = () => {
    const phone = form.value.phone;

    if (!/^(05|06|07)\d{8}$/.test(phone)) {
        formErrors.value.phone.error = true;

    } else {
        formErrors.value.phone.error = false;
    }
};

watch(() => form.value.phone, validatePhone);


const showLoadingModal = ref(false);
const showPasswordAuthModal = ref(false);
const showOtpPhoneModal = ref(false);

const submitNewData = () => {
    showLoadingModal.value = true;

    setTimeout(() => {

        if (!validateFields()) {
            showLoadingModal.value = false;
            return;
        }

        showLoadingModal.value = false;

        if (form.value.phone != adminStore.phone) {
            showOtpPhoneModal.value = true;
        } else {
            showPasswordAuthModal.value = true;
        }
    }, 1000);
}


const validateFields = () => {
    let valid = true;


    Object.keys(formErrors.value).forEach(key => {
        formErrors.value[key].error = false;
        formErrors.value[key].message = '';
    });


    if (!form.value.email) {
        formErrors.value.email = { error: true, message: "• Email is required" };
        valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.value.email)) {
        formErrors.value.email = { error: true, message: "• Invalid email format" };
        valid = false;
    }


    if (!form.value.phone) {
        formErrors.value.phone = { error: true, message: "• Phone number is required" };
        valid = false;
    } else if (!/^(05|06|07)\d{8}$/.test(form.value.phone)) {
        formErrors.value.phone = { error: true, message: "• Invalid phone number" };
        valid = false;
    }


    if (form.value.newPassword && form.value.newPassword.length < 8) {
        formErrors.value.newPassword = { error: true, message: "weakPassword" };
        valid = false;
    }


    if (form.value.newPassword && form.value.confirmNewPassword !== form.value.newPassword) {
        formErrors.value.confirmNewPassword = { error: true, message: "passwordMismatch" };
        valid = false;
    }

    return valid;
};

const showSuccessfullUpdateModal = ref(false);


const successfulUpdate = () => {
    showPasswordAuthModal.value = false;
    showSuccessfullUpdateModal.value = true;

    setTimeout(() => {
        showSuccessfullUpdateModal.value = false;

    }, 2000);
}


const passToPasswordConfirmation = () => {
    showOtpPhoneModal.value = false;
    showPasswordAuthModal.value = true;
}


const cancelEdit = () => {
    showPasswordAuthModal.value = false;
    showOtpPhoneModal.value = false;
    showSuccessfullUpdateModal.value = false;
}


const errorOnUpdate = (errorMessages) => {

    showPasswordAuthModal.value = false;
    showOtpPhoneModal.value = false;

    Object.keys(formErrors.value).forEach(key => {
        formErrors.value[key].error = false;
        formErrors.value[key].message = '';
    });


    Object.entries(errorMessages).forEach(([field, code]) => {
        if (formErrors.value[field] !== undefined) {
            formErrors.value[field].error = true;
            formErrors.value[field].message = code;
        }
    });
};


const cancelOtpconfirmation = () => {
    showOtpPhoneModal.value = false;
}

</script>

<style scoped>
@keyframes bounce-wave {

    0%,
    80%,
    100% {
        transform: translateY(0);
    }

    40% {
        transform: translateY(-8px);
    }
}

.animate-bounce-wave {
    animation: bounce-wave 1.2s infinite ease-in-out;
}

.delay-0 {
    animation-delay: 0s;
}

.delay-150 {
    animation-delay: 0.15s;
}

.delay-300 {
    animation-delay: 0.3s;
}

/* Remove arrows for Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Remove arrows for Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
</style>
